import axios from 'axios'

/**
 * 修改邮箱第一步
 * @param params
 * @returns {Promise<any>}
 */
export async function updateEmailFirst(params) {
  const { data } = await axios.post('/userCenter/account/oldEmialSmsCodeVerify', params)
  return data
}

/**
 * 通过邮箱获取验证码：绑定邮箱第一步获取验证码,修改邮箱第一步获取验证码,修改邮箱第二步获取验证码
 * @param params
 * @returns {Promise<any>}
 */
export async function getCodeByMail(params) {
  const { data } = await axios.post('/userCenter/account/sendUpdateEmailMailCode', params)
  return data
}

/**
 * 修改密码
 * @param params
 * @returns {Promise<any>}
 */
export async function updateInfo(params) {
  const { data } = await axios.post('/userCenter/account/update-info', params)
  return data
}

/**
 * 重置密码获取验证码
 * @param params
 * @returns {Promise<any>}
 */
export async function changePwdCode(params) {
  const { data } = await axios.post('/userCenter/account/sendUpdatePwdSmsCode', params)
  return data
}

/**
 * 获取实名认证地址
 * @param params
 * @returns {Promise<any>}
 */
export async function idCardAudit(params) {
  const { data } = await axios.post('/ecoSystem/api/v1/account/person/id-card-audit', params)
  return data
}

/**
 * 上传个人头像
 * @param params
 * @returns {Promise<any>}
 */
export async function updateAccountLogo(params) {
  const { data } = await axios.post('/ecoSystem/api/v1/account/update-logo', params)
  return data
}

/**
 * 绑定修改邮箱/修改密码极验初始化接口
 * @param params
 * @return {Promise<any>}
 */
export async function geeInit(params) {
  const { data } = await axios.post('/userCenter/newcoreorg/company/geeGeetestInit', params)
  return data
}
/**
 * 检查是否扫码授权
 * @param params
 * @return {Promise<any>}
 */
export async function checkIsScan(params) {
  const { data } = await axios.post('/userCenter/accountSetting/checkIsScan', params)
  return data
}
/**
 * 生成微信服务号二维码
 * @param params
 * @return {Promise<any>}
 */
export async function genWxServiceQrCode(params) {
  const { data } = await axios.post('/userCenter/accountSetting/genWxServiceQrCode', params)
  return data
}
/**
 * 是否绑定了微信服务号
 * @param params
 * @return {Promise<any>}
 */
export async function isBindWxService(params) {
  const { data } = await axios.post('/userCenter/accountSetting/isBindWxService', params)
  return data
}
/**
 * 解绑微信服务号
 * @param params
 * @return {Promise<any>}
 */
export async function unBindWxService(params) {
  const { data } = await axios.post('/userCenter/accountSetting/unBindWxService', params)
  return data
}
